import jQuery from 'jquery';

export default class DatePicker {
    createDatePicker(datePickerSelector, config) {
        var datePicker;

        setTimeout(function () {
            datePicker = window.jQuery(datePickerSelector).datepicker(config);

            jQuery(datePickerSelector).trigger('click');

            jQuery('body').trigger('click');
        }, 500);
    }
}
